import { CLASSIFICATION_TYPE, PAGE_TYPE } from "../../constants";
import { eventTrackPayloadCreator } from "../../helpers/eventPayloadCreator";
import { EventData, EventPayload } from "../../types";

export interface ApplyChangesCTAClickedPayload extends EventPayload {
  content: {
    title: string;
  };
  orderId: string;
  productId: string;
}

const ApplyChangesCtaClickedEventData: EventData = {
  eventName: "Apply Changes CTA Clicked",
  classification: CLASSIFICATION_TYPE.experienceEvent,
  pageType: PAGE_TYPE.orderHistory,
};

export const createApplyChangesCTAClickedEventPayload =
  eventTrackPayloadCreator<ApplyChangesCTAClickedPayload>(
    ApplyChangesCtaClickedEventData,
  );
